module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/56e2d9ca862c88d25bd103a62e8a0e13.png";